import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gessp',
  templateUrl: './gessp.component.html',
  styleUrls: ['./gessp.component.css']
})
export class GesspComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
